import { HttpMethod, Performer } from '../core'

export class TakeTask extends Performer<
  {
    payload: {
      taskId: string
    }
  },
  {
    success: boolean
  }
> {
  protected method = HttpMethod.POST
  protected url = '/take-task'
}
